export const PLATFORM_NAME = "NEXTMIND INFISSI";
export const PLATFORM_SUBTITLE = "Piattaforma Preventivi AI";
export const PLATFORM_MARK = "/brand/nextmind-mark.svg";

// Public/platform brand only: deterministic, never depends on tenant branding or auth state.
export default function PlatformLogo({ size = 40, dark = true, showText = true, subtitle = false, className = "", testId = "platform-logo" }) {
  const text = dark ? "text-white" : "text-[#0F172A]";
  const sub = dark ? "text-slate-400" : "text-slate-500";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid={testId}>
      <img src={PLATFORM_MARK} alt={PLATFORM_NAME} width={size} height={size} className="rounded-xl shrink-0" style={{ width: size, height: size }} data-testid={`${testId}-img`} />
      {showText && (
        <div className="leading-tight">
          <div className={`font-heading font-extrabold tracking-tight ${text}`} style={{ fontSize: Math.max(14, Math.round(size * 0.5)) }}>{PLATFORM_NAME}</div>
          {subtitle && <div className={`text-xs ${sub}`}>{PLATFORM_SUBTITLE}</div>}
        </div>
      )}
    </div>
  );
}
